<template>
  <div class="managingPeople hp100 bbox" v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->

      <el-row :gutter="20" type="flex" justify="space-between">
        <el-form :inline="true" :model="searchInput">
          <el-col :span="2">
            <el-form-item>
              <el-button plain class="add-column-btn bbox" @click="dialogFormVisible = true" type="primary">
                <i class="el-icon-plus fw900 f16"></i> 新增</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-input v-model="searchInput.projectName" placeholder="请输入项目名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-date-picker v-model="searchInput.startDt" type="date" value-format="yyyy-MM-dd" placeholder="预计回款时间从">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-date-picker v-model="searchInput.endDt" type="date" value-format="yyyy-MM-dd" placeholder="预计回款时间至">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-select v-model="searchInput.status" placeholder="请选择">
                <el-option v-for="item in backState" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item>
              <el-button type="primary" style="margin-left: 20px" @click="search">搜索</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item>
              <el-button type="primary" style="margin-left: 20px">本周回款金额：{{ weekbackmoney }}</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <!-- 用户列表区域 -->
      <div :style="{ height: height + 'px' }">

        <el-table :data="tableData" show-summary border fit highlight-current-row style="width: 100%"
          :summary-method="summaryMethod" @sort-change="sortChange" :row-class-name="tableRowClassName"
          :height="height + 'px'" ref="tableRef">
          <el-table-column label="项目名称" align="center" prop="" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.projectName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="回款金额" align="center" prop="amount" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.amount }}</span>
            </template>
          </el-table-column>

          <el-table-column label="制定时间" align="center" prop="制定时间" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.createDt }}</span>
            </template>
          </el-table-column>

          <el-table-column label="预计回款时间" align="center" prop="预计回款时间" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.planDt }}</span>
            </template>
          </el-table-column>
          <el-table-column label="时长" align="center" prop="时长">
            <template slot-scope="scope">
              <span>{{ scope.row.times }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center" prop="备注" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" prop="状态" width="80">
            <template slot-scope="scope">
              <span>{{
                scope.row.status == "00" ? "未回款" : "已回款"
                }}</span>
            </template>
          </el-table-column>

          <el-table-column label="实际回款时间" align="center" prop="回款时间" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.returnDt">{{
                scope.row.returnDt
                }}</span>
              <span v-else> </span>
            </template>
          </el-table-column>
          <el-table-column label="计划创建人" align="center" prop="创建人" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.creator }}</span>
            </template>
          </el-table-column>
          <el-table-column label="回款标记人" align="center" prop="回款人" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.returnor }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="300">
            <template slot-scope="scope">
              <el-tag class="pointer" v-if="scope.row.status == '00'" @click="gotoDetail(scope.row)"
                style="margin-right: 10px">修改</el-tag>
              <el-tag class="pointer" type="danger" v-if="scope.row.status == '00'" @click="gotoRemark(scope.row.id)"
                style="margin-right: 10px">标记已回款</el-tag>
              <el-tag class="pointer" type="success" @click="gotoPlanRecords(scope.row.planCode)">修改记录</el-tag>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage" :page-sizes="[50, 100, 300]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </el-card>
    <!-- 标记已回款弹窗 -->
    <el-dialog title="修改记录: " :visible.sync="dialogRemark" style="width: 50%; margin: 0 auto" center>
      <div style="text-align: center; font-size: 18px">确定标记已回款?</div>
      <div class="twonbtn" style="width: 180px; margin: 20px auto">
        <el-button type="primary" style="margin-right: 20px" @click="submitRemark">确定</el-button>
        <el-button @click="dialogRemark = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 修改记录弹窗 -->
    <el-dialog title="修改记录: " :visible.sync="dialogFormRecord" style="width: 80%; margin: 0 auto" center>
      <div class="tableBox">
        <el-table :data="recordData" border style="width: 100%; margin: 20px auto" highlight-current-row
          :header-cell-style="{ background: '#f7f7f7' }">
          <el-table-column prop="originalPlanDt" label="原预计回款时间" align="center">
          </el-table-column>
          <el-table-column prop="nowPlanDt" label="修改后预计回款时间" align="center">
          </el-table-column>
          <el-table-column prop="originalAmount" label="原回款金额" align="center">
          </el-table-column>
          <el-table-column prop="amount" label="修改后回款金额" align="center">
          </el-table-column>
          <el-table-column prop="originalRemark" label="原备注" align="center">
          </el-table-column>
          <el-table-column prop="remark" label="修改后备注" align="center">
          </el-table-column>
          <el-table-column prop="creator" label="修改人" align="center">
          </el-table-column>
          <el-table-column prop="createDt" label="修改时间" align="center">
          </el-table-column>
        </el-table>
        <div class="footerBox">
          <!-- 分页区域 -->
          <el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3"
            :current-page.sync="queryInfo3.currPage" :page-sizes="[10, 20, 30, 50]" :page-size="queryInfo3.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total3"></el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 新增弹窗 -->
    <el-dialog title="新增: " :visible.sync="dialogFormVisible" style="width: 80%; margin: 0 auto" center
      @close="cancelAdd">
      <div class="tableBox">
        <el-form :inline="true" :rules="rules" :model="editForm" label-position="right" label-width="150px"
          style="margin-left: 20px">
          <el-col :span="24">
            <el-form-item label="项目名称：" prop="projectName">
              <el-input v-model="editForm.projectName"></el-input>
            </el-form-item>
            <el-button type="primary" style="margin-left: 50px" @click="showDialogproject">选择</el-button>
          </el-col>
          <el-col :span="24">
            <el-form-item label="回款金额：" prop="amount">
              <el-input v-model="editForm.amount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="预计回款时间：" prop="planDt">
              <el-date-picker v-model="editForm.planDt" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注：">
              <el-input v-model="editForm.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
        <div class="twonbtn" style="width: 180px; margin: 20px auto">
          <el-button type="primary" style="margin-right: 20px" @click="submitEditform">保存</el-button>
          <el-button @click="dialogFormVisible = false">取消</el-button>
        </div>
      </div>
      <!-- 小弹窗 -->
      <el-dialog title="选择项目: " :visible.sync="dialogProjectList" style="width: 90%; margin: 0 auto" append-to-body>
        <el-form :inline="true" :model="selectInput2">
          <el-col :span="24" style="margin-left: 20px">
            <el-form-item label="项目名称： ">
              <el-input v-model="selectInput2.projectName" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="margin-left: 20px" @click="searchProject()">查询</el-button>
            </el-form-item>
          </el-col>
        </el-form>
        <el-table :data="projectData" border style="width: 100%; margin: 20px auto" highlight-current-row
          :header-cell-style="{ background: '#f7f7f7' }" @row-click="singleElection" stripe>
          <el-table-column width="65">
            <template slot-scope="scope">
              <el-radio class="radio" v-model="templateSelection" :label="scope.$index">&nbsp;&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="projectName" label="项目名称" align="center">
          </el-table-column>
          <el-table-column prop="businessDirectorName" label="商务负责人" align="center">
          </el-table-column>
          <el-table-column prop="projectApprovalTime" label="立项时间" align="center">
          </el-table-column>
          <el-table-column prop="conclusionTime" label="结项时间" align="center">
          </el-table-column>
          <el-table-column prop="pprojectTime" label="工期" align="center">
          </el-table-column>
        </el-table>
        <div class="twobtn" style="width: 100%; margin: 20px auto">
          <el-button type="primary" style="margin-right: 20px" @click="submitCurrrow">选择</el-button>
          <el-button @click="dialogProjectList = false">取消</el-button>
        </div>
        <div class="footerBox">
          <!-- 分页区域 -->
          <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
            :current-page.sync="queryInfo2.currPage" :page-sizes="[10, 20, 30, 50]" :page-size="queryInfo2.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total2"></el-pagination>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight - 180, //表格高度
      value: "",
      searchInput: {
        projectName: "",
        startDt: "",
        endDt: "",
        status: "",
      },
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        currPage: 1,
        pageSize: 300,
        condition: {
          id: "",
        },
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: "",
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
      // ----------------------------------
      weekbackmoney: "",
      backState: [
        {
          value: "00",
          label: "未回款",
        },
        {
          value: "10",
          label: "已回款",
        },
      ],
      dialogFormVisible: false,
      editForm: {
        projectName: "",
        amount: "",
        planDt: "",
        remark: "",
      },
      dialogProjectList: false,
      projectCode: "",
      selectInput2: { projectName: "" }, //弹窗里的搜索
      total2: 0,
      queryInfo2: {
        currPage: 1,
        pageSize: 10,
        condition: {},
      },
      projectData: [{ selectProject: "" }], //弹窗列表
      templateSelection: "",
      templateRadio: "",
      currRow: {},

      // 修改记录弹窗
      dialogFormRecord: false,
      recordData: [],
      planCode: "",
      total3: 0,
      queryInfo3: {
        currPage: 1,
        pageSize: 20,
        condition: {},
      },
      // 标记已回款弹窗
      dialogRemark: false,
      rules: {
        projectName: [
          { required: true, message: "请选择项目名称", trigger: "blur" },
        ],
        amount: [
          { required: true, message: "请输入回款金额", trigger: "blur" },
        ],
        planDt: [
          { required: true, message: "请选择回款时间", trigger: "blur" },
        ],
      },
    };
  },
  // created() {
  //   this.queryInfo.currPage = this.$route.query.currPage;
  //   this.queryInfo.pageSize = this.$route.query.pageSize;
  //   this.getListData();
  //   this.weekBackMoney();
  //   window.addEventListener("resize", this.getHeight);
  //   var that=this;
  //   document.onkeydown = function(e) {   //按下回车提交
  //       let key = window.event.keyCode;
  //       //事件中keycode=13为回车事件
  //       if (key == 13) {
  //         that.getListData();
  //       }
  //   };
  // },
  mounted() {
    this.loading = false;

  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    //条件查询
    search() {
      this.queryInfo.condition = this.searchInput;
      this.getListData();
    },
    // 本周回款
    weekBackMoney() {
      var that = this;
      let data = {};
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      that.$http
        .post("/returnPaymentPlan/queryThisWeek", data)
        .then(function (response) {
          // console.log("本周回款===>", response.data);
          if (response.data.code == 200) {
            that.weekbackmoney = response.data.data;
          }
        });
    },
    // 展示小弹窗
    showDialogproject() {
      this.dialogProjectList = true;
      this.getProjectData();
    },
    //弹窗里的查询
    searchProject() {
      var that = this;
      that.queryInfo2.condition.projectName = that.selectInput2.projectName;
      this.getProjectData();
    },
    // 小弹窗列表
    getProjectData() {
      var that = this;
      that.queryInfo2.condition.userCode = JSON.parse(
        localStorage.getItem("userCode")
      ).value;
      that.$http
        .post("/project/list", that.queryInfo2)
        .then(function (response) {
          console.log("小弹窗列表===>", response.data.data);
          if (response.data.code == 200) {
            that.total2 = response.data.data.count;
            that.queryInfo2.currPage = response.data.data.currPage;
            that.projectData = response.data.data.data;
            for (let i = 0; i < response.data.data.data.length; i++) {
              that.projectData[i].projectApprovalTime = that.timeFormate(
                response.data.data.data[i].projectApprovalTime
              );
              that.projectData[i].conclusionTime = that.timeFormate(
                response.data.data.data[i].conclusionTime
              );
            }
          }
        });
    },
    //只能选择一行，选择其他，清除上一行
    singleElection(row) {
      console.log("当前选中行===>", row);
      this.currRow = row;
      this.templateSelection = this.projectData.indexOf(row);
      console.log("this.templateSelection==>", this.templateSelection);
      this.templateRadio = row.id;
    },
    // 确定选择当前行
    submitCurrrow() {
      this.editForm.projectName = this.currRow.projectName;
      this.editForm.amount = this.currRow.amount;
      this.editForm.planDt = this.currRow.planDt;
      this.editForm.remark = this.currRow.remark;
      this.projectCode = this.currRow.projectCode;
      this.dialogProjectList = false;
    },
    // 保存修改
    submitEditform() {
      if (
        this.editForm.projectName == "" ||
        this.editForm.amount == "" ||
        this.editForm.planDt == ""
      ) {
        this.$message({
          message: "必填信息未填写完整",
          type: "error",
        });
        return;
      }
      let data = {};
      data = this.editForm;
      data.projectCode = this.projectCode;
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      this.$http.post("returnPaymentPlan/save", data).then(response => {
        if (response.data.code == 200) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.dialogFormVisible = false;
          this.getListData();
          // that.clearEditForm();
          // that.editForm = {
          //   projectName: "",
          //     amount: "",
          //     planDt: "",
          //     remark: "",
          // };
        }
      });
    },
    cancelAdd() {
      this.dialogFormVisible = false;
      this.editForm = {
        projectName: "",
        amount: "",
        planDt: "",
        remark: "",
      };
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange2(newSize) {
      this.queryInfo2.pageSize = newSize;
      this.getProjectData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange2(newSize) {
      this.queryInfo2.currPage = newSize;
      this.getProjectData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange3(newSize) {
      this.queryInfo3.pageSize = newSize;
      this.getRecords();
    },
    // 监听 页码值 改变事件
    handleCurrentChange3(newSize) {
      this.queryInfo3.currPage = newSize;
      this.getRecords();
    },
    // 监听排序
    sortChange() { },
    //编辑
    gotoDetail(row) {
      console.log("row==>", row);
      var that = this;
      that.editForm.projectName = row.projectName;
      that.editForm.amount = row.amount;
      that.editForm.planDt = row.planDt;
      that.editForm.remark = row.remark;
      that.editForm.id = row.id;
      this.dialogFormVisible = true;
    },
    clearEditForm() {
      this.editForm.projectName = "";
      this.editForm.amount = "";
      this.editForm.planDt = "";
      this.editForm.remark = "";
    },
    //标记已回款
    gotoRemark(id) {
      this.dialogRemark = true;
      this.projectId = id;
    },
    //指定行颜色
    rowStyle({ row, rowIndex }) {
      return { "background-color": "#8a8a8c" };
    },
    // 确定标记已回款
    submitRemark() {
      var that = this;
      let data = {};
      data.id = that.projectId;
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      that.$http
        .post("/returnPaymentPlan/update", data)
        .then(function (response) {
          console.log("确定标记已回款==>", response.data);
          if (response.data.code == 200) {
            that.$message({
              message: "标记成功",
              type: "success",
            });
            that.dialogRemark = false;
            that.getListData();
          }
        });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.status === "10") {
        return "warning-row";
      }
      return '';
    },
    getListData() {
      // 获取列表
      var that = this;
      that.queryInfo.condition.userCode = JSON.parse(
        localStorage.getItem("userCode")
      ).value;
      that.$http
        .post("/returnPaymentPlan/list", that.queryInfo)
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
            console.log("tabledata===>", that.tableData);
            for (let i = 0; i < that.tableData.length; i++) {
              that.tableData[i].createDt = that
                .timeFormate(response.data.data.data[i].createDt)
                .substr(0, 11);
              if (that.tableData[i].planDt) {

                that.tableData[i].planDt = that
                  .timeFormate(response.data.data.data[i].planDt)
                  .substr(0, 11);
                that.$nextTick(() => {
                  that.$refs.tableRef.doLayout();
                })
              }
            }
          }
        });
    },
    // 修改记录
    gotoPlanRecords(planCode) {
      this.dialogFormRecord = true;
      this.planCode = planCode;
      this.getRecords();
    },
    getRecords() {
      var that = this;
      that.queryInfo3.condition.planCode = that.planCode;
      that.queryInfo3.condition.userCode = JSON.parse(
        localStorage.getItem("userCode")
      ).value;
      that.$http
        .post("/returnPaymentPlanRecords/list", that.queryInfo3)
        .then(function (response) {
          console.log("修改记录==>", response.data.data);
          if (response.data.code == 200) {
            that.total3 = response.data.data.count;
            that.queryInfo3.currPage = response.data.data.currPage;
            that.recordData = response.data.data.data;
            for (let i = 0; i < response.data.data.data.length; i++) {
              that.recordData[i].createDt = that.timeFormate(
                response.data.data.data[i].createDt
              );
            }
          }
        });
    },
    // 合计行只保留两位小数
    summaryMethod(params) {
      const { columns, data } = params;
      const sums = [];
      columns.forEach((column, index) => {
        // 这里可以指定哪些字段需要合计，哪些需要格式化小数，示例针对金额相关的字段处理。
        if (
          ['amount'].includes(column.property)
        ) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            const total = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + value;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = total.toFixed(2);
          } else {
            sums[index] = '';
          }
        } else if (index === 0) {
          sums[index] = '合计';
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
    // 时间格式化
    timeFormate(originVal) {
      const dt = new Date(originVal);

      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "").padStart(2, "0");
      const d = (dt.getDate() + "").padStart(2, "0");

      const hh = (dt.getHours() + "").padStart(2, "0");
      const mm = (dt.getMinutes() + "").padStart(2, "0");
      const ss = (dt.getSeconds() + "").padStart(2, "0");
      // yyyy-mm-dd hh:mm:ss
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },
  },
  created() {
    this.getListData();
    this.weekBackMoney();
  },
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}

.pointer:hover {
  cursor: pointer;
}

.managingPeople {

  .el-form-item--small.el-form-item {
    margin-bottom: 5px !important;
  }

  .el-card {
    height: calc(100vh - 80px);
    position: relative;

    /deep/.el-card__body {
      // height: 100%;
      padding: 0 20px 0 20px !important;
    }


    .el-select>.el-input {
      width: 200px;
    }

    .header-search-box .header-search-input {
      width: 325px;
    }

    input::placeholder {
      font-size: 12px;
    }

    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }

    .footerBox {
      // position: absolute;
      width: 100%;
      margin: 20px 0;
      // height: 78px;
      // left: 20px;
      // right: 20px;
      // bottom: 0;
    }
  }
}

/deep/.el-scrollbar__view {
  min-width: 100%;
}

/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}

/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}

//日期选择器
/deep/.el-date-editor.el-input {
  width: 188.5px;
}

/deep/.el-dialog__body {
  padding: 20px;
}

/deep/.el-pagination {
  margin-top: 0;
}

/deep/.el-table .warning-row {
  background: #a3a3a6;
  ;
}
</style>
